module.exports = __webpack_public_path__ + "img/remote_unlock.52dc2f7c.png";